type Props = { props: Record<string, string | number | boolean> }

export function TestimonialPreview({ props: p }: Props) {
  return (
    <div className="text-center py-3 px-4 bg-tf-bg-muted rounded-lg border border-tf-border-sub">
      <div className="flex justify-center mb-2">
        {Array.from({ length: p.rating as number }).map((_, i) => (
          <span key={i} className="text-yellow-400 text-lg">&#9733;</span>
        ))}
      </div>
      <p className="text-sm italic text-tf-text-sub">{p.quote as string}</p>
      <p className="text-xs text-tf-text-muted mt-2">&mdash; {p.author as string}</p>
    </div>
  )
}
